export const heroStats = [
  { label: "收录事件", value: "2,847", unit: "起" },
  { label: "解析报告", value: "613", unit: "份" },
  { label: "关联人物", value: "1,204", unit: "位" },
  { label: "线索来源", value: "37", unit: "类" },
];

export const heroTags = ["利益链", "动机分析", "舆情反转", "关联人物", "时间线复原"];

export const topics = [
  { name: "合约纠纷", heat: "high", count: 148 },
  { name: "直播分成", heat: "high", count: 132 },
  { name: "数据注水", heat: "high", count: 121 },
  { name: "舆情反转", heat: "high", count: 117 },
  { name: "资本运作", heat: "high", count: 96 },
  { name: "人设争议", heat: "mid", count: 88 },
  { name: "团队内讧", heat: "mid", count: 79 },
  { name: "代言解约", heat: "mid", count: 74 },
  { name: "打投乱象", heat: "mid", count: 66 },
  { name: "流量造假", heat: "mid", count: 61 },
  { name: "饭圈脱粉", heat: "low", count: 54 },
  { name: "合同漏洞", heat: "low", count: 47 },
  { name: "公关话术", heat: "low", count: 43 },
  { name: "时间线矛盾", heat: "low", count: 39 },
  { name: "账号归属", heat: "low", count: 34 },
  { name: "截图溯源", heat: "low", count: 31 },
  { name: "出镜背景", heat: "low", count: 27 },
  { name: "行程冲突", heat: "low", count: 22 },
];

export const heatRanking = [
  {
    rank: 1,
    title: "星野工作室合约解约风波",
    category: "合约纠纷",
    heat: 98,
    trend: "up",
    delta: 42,
    summary: "双方口径在同一天内出现三次变化，解约时间点与代言排期高度重合。",
  },
  {
    rank: 2,
    title: "云深传媒分成比例争议",
    category: "直播分成",
    heat: 94,
    trend: "up",
    delta: 31,
    summary: "流水截图与官方公布数字存在区间差，争议核心落在结算周期上。",
  },
  {
    rank: 3,
    title: "林晚舟账号归属疑云",
    category: "账号归属",
    heat: 89,
    trend: "flat",
    delta: 4,
    summary: "注册手机号与运营团队重合，但运营方坚称账号为个人独立所有。",
  },
  {
    rank: 4,
    title: "顾承安代言集体下架事件",
    category: "代言解约",
    heat: 85,
    trend: "down",
    delta: -9,
    summary: "品牌方下架动作集中在四十八小时内，节奏与舆情峰值几乎同步。",
  },
  {
    rank: 5,
    title: "栖迟文化数据注水调查",
    category: "数据注水",
    heat: 81,
    trend: "up",
    delta: 18,
    summary: "播放曲线在凌晨出现规律性拉升，去水后留存率不足对外口径三成。",
  },
  {
    rank: 6,
    title: "沈亦白团队内讧时间线",
    category: "团队内讧",
    heat: 76,
    trend: "up",
    delta: 12,
    summary: "三名前员工离职时间集中在同一个月，恰好早于项目停更公告。",
  },
  {
    rank: 7,
    title: "南栀直播间分成协议外泄",
    category: "直播分成",
    heat: 72,
    trend: "flat",
    delta: -2,
    summary: "协议页脚版本号与官方模板不一致，疑似存在非公开附加条款。",
  },
  {
    rank: 8,
    title: "叙白经纪约跳槽争议",
    category: "合约纠纷",
    heat: 68,
    trend: "down",
    delta: -14,
    summary: "新旧两家公司的公告间隔不足一小时，先后顺序本身成了关键线索。",
  },
];

export const deepAnalyses = [
  {
    id: "report-0613",
    angle: "真相还原",
    title: "把三份互相矛盾的声明摊在同一张时间轴上",
    excerpt:
      "同一件事，官方在二十四小时内给出了三种说法。我们不做情绪判断，只把公告、截图与行程排期逐条对齐，看看哪一条在时间线上根本站不住脚。",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20torn%20paper%20layers%20revealing%20hidden%20text%2C%20warm%20cream%20and%20ash%20grey%20tones%2C%20abstract%20metaphor%20for%20truth%20revealed%2C%20soft%20directional%20light%2C%20minimal%20editorial%20still%20life%2C%20consistent%20warm%20dark%20palette&width=900&height=640&seq=heihiao-cover-a1&orientation=landscape",
    tags: ["时间线", "声明比对", "证据链"],
    reportNo: "HP-0613",
    updated: "2 小时前",
    readTime: "12 分钟",
  },
  {
    id: "report-0587",
    angle: "动机分析",
    title: "谁在那个节点选择开口，谁又刚好保持沉默",
    excerpt:
      "我们梳理了所有公开发声的账号及其发声时点，发现开口的顺序与各自承受的商业压力高度相关，这或许比内容本身更能说明问题。",
    image:
      "https://readdy.ai/api/search-image?query=Intertwined%20metal%20chains%20on%20a%20dark%20matte%20surface%2C%20warm%20amber%20rim%20light%2C%20abstract%20metaphor%20for%20motive%20and%20conflict%20of%20interest%2C%20moody%20studio%20photography%2C%20consistent%20warm%20dark%20palette&width=900&height=640&seq=heihiao-cover-a2&orientation=landscape",
    tags: ["发声时点", "利益测算", "沉默成本"],
    reportNo: "HP-0587",
    updated: "昨天",
    readTime: "9 分钟",
  },
  {
    id: "report-0542",
    angle: "利益链",
    title: "顺着股权与分成，把台前幕后连成一张网",
    excerpt:
      "台前是对立的两方，台后却共享同一条供应链。我们按股权、合作与结算路径画出关系图，看清争执的边界究竟在哪里。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20network%20of%20glowing%20threads%20connecting%20nodes%20on%20charcoal%20surface%2C%20warm%20crimson%20and%20amber%20accents%2C%20metaphor%20for%20hidden%20interest%20chains%2C%20moody%20studio%20lighting%2C%20editorial%20photography%2C%20consistent%20warm%20dark%20palette&width=900&height=640&seq=heihiao-cover-a3&orientation=landscape",
    tags: ["股权结构", "结算路径", "合作重叠"],
    reportNo: "HP-0542",
    updated: "2 天前",
    readTime: "15 分钟",
  },
  {
    id: "report-0509",
    angle: "关联人物",
    title: "被忽略的第五个人，恰好握着关键的一票",
    excerpt:
      "大众视线聚焦在两位当事人身上，但决策链条里还有一个长期隐身的角色。我们从出席记录与署名顺序里，把他的位置补了回来。",
    image:
      "https://readdy.ai/api/search-image?query=Chess%20pieces%20standing%20in%20dramatic%20warm%20spotlight%20on%20a%20dark%20background%2C%20abstract%20metaphor%20for%20strategy%20and%20motive%2C%20cinematic%20editorial%20still%20life%2C%20consistent%20warm%20dark%20palette&width=900&height=640&seq=heihiao-cover-a4&orientation=landscape",
    tags: ["决策链条", "署名顺序", "出席记录"],
    reportNo: "HP-0509",
    updated: "3 天前",
    readTime: "11 分钟",
  },
];

export const motiveChain = [
  {
    no: "01",
    title: "触发点",
    desc: "一条模糊的爆料被放出，信息量极低，却精准踩中公众的既有猜测。",
    keyword: "诱因",
  },
  {
    no: "02",
    title: "放大",
    desc: "搬运与二创在数小时内铺开，原始信源被反复转述，细节开始失真。",
    keyword: "扩散",
  },
  {
    no: "03",
    title: "站队",
    desc: "相关方陆续表态，先开口的往往是承受商业压力更小的一方。",
    keyword: "表态",
  },
  {
    no: "04",
    title: "反转",
    desc: "新证据出现，早期叙事被推倒，但流量已经完成一轮收割。",
    keyword: "拐点",
  },
  {
    no: "05",
    title: "沉淀",
    desc: "热度退去，只剩下一份被简化过的结论，真相往往停在了这里。",
    keyword: "余波",
  },
];

export const peopleMap = [
  {
    name: "林晚舟",
    role: "当事人",
    relation: "账号注册人与出镜主体",
    affinity: 96,
    tags: ["核心", "出镜"],
    initials: "林",
  },
  {
    name: "顾承安",
    role: "合作方",
    relation: "代言排期与其行程高度重合",
    affinity: 78,
    tags: ["商业", "关联"],
    initials: "顾",
  },
  {
    name: "沈亦白",
    role: "前团队成员",
    relation: "离职时间早于项目停更公告",
    affinity: 71,
    tags: ["内部", "证言"],
    initials: "沈",
  },
  {
    name: "栖迟文化",
    role: "运营机构",
    relation: "持有结算账户与数据后台权限",
    affinity: 88,
    tags: ["机构", "结算"],
    initials: "栖",
  },
  {
    name: "云深传媒",
    role: "渠道方",
    relation: "分成协议的对外公示版本持有者",
    affinity: 64,
    tags: ["渠道", "协议"],
    initials: "云",
  },
  {
    name: "南栀",
    role: "旁观发声者",
    relation: "最早公开梳理时间线的第三方账号",
    affinity: 52,
    tags: ["第三方", "梳理"],
    initials: "南",
  },
];

export const compareRows = [
  {
    dim: "事件起因",
    surface: "一次普通的合作分歧",
    truth: "分歧早于爆料两周，只是当时无人关注",
  },
  {
    dim: "曝光时点",
    surface: "恰好与项目宣传期撞车",
    truth: "宣传排期在爆料前已定，撞车并非巧合",
  },
  {
    dim: "双方态度",
    surface: "一边强硬，一边回避",
    truth: "强硬方更早接触公关团队，回避方则在等结算",
  },
  {
    dim: "关键证据",
    surface: "一张来源不明的聊天截图",
    truth: "截图页脚版本号指向同一台运营设备",
  },
  {
    dim: "最终走向",
    surface: "双方各退一步、低调收场",
    truth: "真正的分歧转移到了背后的渠道分成上",
  },
];

export const navLinks = [
  { label: "话题墙", href: "#topics" },
  { label: "热度榜", href: "#ranking" },
  { label: "深度解析", href: "#reports" },
  { label: "动机链条", href: "#chain" },
  { label: "人物图谱", href: "#people" },
];